export const handleInputSelect = () => {
  document.getElementById('loader-container').style.display = 'none';
};
